import React, { createContext, useState, useEffect, Dispatch, SetStateAction } from 'react';
import ReactDOM from 'react-dom';
import { Jumbotron } from '../../../../infrastructure/components/Layout/Jumbotron';
import { STATUS } from '../../../../application/common/constants';
import Button from 'react-bootstrap/Button';
import UserManager, { AUTH_STATUS } from '../../../../application/common/usermanagement';
import { Spinner } from '../../../../infrastructure/components/Loading/Spinner';
import config from '../../../../application/common/config';
import './Login.css';
import axios from 'axios';

export const Login: React.FC = () => {
  const [status, setStatus] = useState<STATUS>(STATUS.LOADING);
  useEffect(() => {
    if (status === STATUS.COMPLETE) {
      return;
    }
    let isMounted = true;
    authenticate().then(result => {
      ReactDOM.render(
        result,
        document.getElementById("loginView")
      );
      if (isMounted) setStatus(STATUS.COMPLETE);
    })
    return () => { isMounted = false };
  }); 

  function retryLogin() {
    UserManager.logoutUser();
    window.location.href = location.protocol + '//' + location.host + location.pathname;
  }

  // pass the data to receiving component (EditUser)
  const sendData = async(schoolId: string | null) =>{
    localStorage.clear(); // clear out any info previously stored
    if (schoolId != null){
    const serviceAcc = {
      "accountName": `${config.ACCOUNT}`,
      "password": `${config.PASSWORD}`,
      "context": "All"
    }
    let bearerToken = "";
    try{
      // console.log(`${config.SERVICE_URL_API}`);
      const responseToken = await axios.post(`${config.SERVICE_URL_API}/auth/token`, serviceAcc);
      // console.log(responseToken.data);
      bearerToken = responseToken.data.SERVICETOKEN;
    }
    catch(error){
      console.log(error);
      bearerToken = "";
    }
    // do the GET call to see if user in Kuali   
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      'API-Key': 'Bearer ' + `${config.KUALI_BEARER}`,
    }; 
    const data = {
      Id: '',
      FirstName: '',
      LastName: '',
      Email: ''
    };
    try{
      const response = await axios.get(`${config.SERVICE_URL_API}/Kuali/GetUser/SchoolId/`+schoolId, {headers});
      // console.log("User info in Kuali: ", response.data);
      if (response.data == "Response has no data"){
        try{
          // console.log(`${config.SERVICE_URL_API}`);
          const getInfo = await axios.get(`${config.SERVICE_URL_API}/system/Account/`+schoolId, {
            headers:  {Authorization: `Bearer ${bearerToken}`}
          });
          // console.log(getInfo.data);
          const jsonObject = JSON.parse(getInfo.data);  // parse the JSON string to JSON object
          if (jsonObject.ComputingId != null){   // if the user info is valid
          // add user to Kuali
          const postUser = {
            "name": jsonObject.CommonName,
            "username": jsonObject.CommonName,
            "email": jsonObject.EmailAddress,
            "firstName": jsonObject.FirstNames,
            "lastName": jsonObject.LastName,
            "schoolId":  jsonObject.ComputingId     
          }
          
          // get the bearer token from PlatfromIntegratorCoreTask
          let bearerToken2 = "";
          try{
            // console.log(`${config.SERVICE_URL_API}`);
            const responseToken2 = await axios.post(`${config.SERVICE_URL_TASK}/auth/token`, serviceAcc);
            // console.log(responseToken2.data);
            bearerToken2 = responseToken2.data.serviceToken;
          }
          catch(error){
            console.log(error);
            bearerToken2 = "";
          };
          try{
          // console.log(`${config.SERVICE_URL_API}`);
          const postInfo = await axios.post(`${config.SERVICE_URL_TASK}/Kuali/CreateUser/Email/`+postUser.email+'?name='+postUser.name+
          '&username='+postUser.username+'&firstName='+postUser.firstName+'&lastName='+postUser.lastName+'&schoolId='+postUser.schoolId, postUser, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearerToken2}`,
              'API-Key': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY0NzhkNzg0NGZhNTBmMDAxNWRlMzk1NyIsImlzcyI6Imt1YWxpLmNvIiwiZXhwIjoxNzE3MjYzNDkyLCJpYXQiOjE2ODU2NDEwOTJ9.KKM1gAVfJyY8xvFLnS9zUg9xG-5Dnwuv0nUtKB9Tsos'
            }
          });
          // console.log("Added user to Kuali: ", postInfo.data);

          // do get call to get the added user's info:
          try{
            // console.log(`${config.SERVICE_URL_API}`);
            const addedUser = await axios.get(`${config.SERVICE_URL_API}/Kuali/GetUser/SchoolId/`+postUser.schoolId, {headers});
            // console.log("The added user was: ", addedUser.data);
  
            // bring up form with prefilled attributes
            data.Id = addedUser.data.ID;
            data.FirstName = addedUser.data.FIRSTNAME;
            data.LastName = addedUser.data.LASTNAME;
            data.Email = addedUser.data.EMAIL;
            // console.log("The passing Id is: ", data.Id);
            }catch(err){
              console.log(err);
              alert("Added user's info wasn't retrieved");
              // logout user
              UserManager.logoutUser();
            }
          }catch(error){
            console.log(error);
            alert("User wasn't added to Kuali: User email not found, duplicated or user might be inActive!");
            // logout user
            UserManager.logoutUser();
          }
        }
        else{
          // logout user
          UserManager.logoutUser();
        }
        }
        catch(error){
          console.log(error);
          alert("User info retrieval failed");
          // logout user
          UserManager.logoutUser();
        }
      }
      else{
        // bring up form with prefilled attributes since user present in Kuali
        data.Id = response.data.ID;
        data.FirstName = response.data.FIRSTNAME;
        data.LastName = response.data.LASTNAME;
        data.Email = response.data.EMAIL;
        // console.log("The passing Id is: ", data.Id);
      }
      // send data to receiving component 
      localStorage.setItem('data', JSON.stringify(data));
      window.location.href = '/';
    }
    catch(error){
      console.log(error);
      alert("Couldn't retrieve data for user associated to CAS ticket!");
      // logout user
      UserManager.logoutUser();
    }
  }
  else{
    alert("ComputingId invalid or not found!");
    // logout user
    UserManager.logoutUser();
  }
  }

  const authenticate = async () => {
    let authStatus: AUTH_STATUS = AUTH_STATUS.NONE;
    if (!(await UserManager.checkTokenAndRefresh())) {  
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      if (!urlParams.get('ticket')) {                   
        UserManager.casRedirect();
        setStatus(STATUS.COMPLETE);
        return (
          <Jumbotron title="Redirecting..."/>
        );
      }
      // if the ticket paramater is present, login and get token for this ticket
      authStatus = await UserManager.loginAndGetToken(window.location.href.replace("?ticket", "&ticket"));
      if (authStatus == AUTH_STATUS.AUTHENTICATED){
        // get the computingID
        const schoolId = UserManager.getComputingId();
        // console.log(schoolId);
        await sendData(schoolId); 
      }
    } else {
      authStatus = AUTH_STATUS.UNAUTHORIZED;
    }
    
    setStatus(STATUS.COMPLETE);
    switch (authStatus) {
      case AUTH_STATUS.AUTHENTICATED:
        window.location.reload();
        return (
          <>
          <Jumbotron title="Redirecting..."/>
          </>
        );
      case AUTH_STATUS.UNAUTHORIZED:
        return (
          <Jumbotron title="Unauthorized">
            <p>You are not authorized to access this application. Please contact your supervisor to get granted the following permission (Kuali User).</p>
            <Button variant="primary" className="me-2" onClick={() => retryLogin()}>
              Click to Retry
            </Button> 
          </Jumbotron>
        );
      case AUTH_STATUS.ERROR:
      default:
        return (
          <Jumbotron title="Error">
            <p>An error occurred when trying to log into this application. Please contact the Office of Research Ethics for assistance, or try again below.</p>
            <Button variant="primary" className="me-2" onClick={() => retryLogin()}>
              Click to Retry
            </Button>
          </Jumbotron>
        );
    }
  };

  return (
    <>
      <Spinner status={status} displayCondition={status === STATUS.LOADING}/>
    </>
  );
};
